export default import.meta.ROLLDOWN_FILE_URL_$qYZ7S1e7TjKHvypkiJ9lw